<template>
<div class="tg-noMore text-center text-light padding50 flex-container" style="display: none" v-show="!midDataNoMore&&items.length&&html">
	<div style="background-image: linear-gradient(90deg, rgba(0,0,0,0.00) 11%, #D8D8D8 100%);height:1px" class="flex1 marginr20"></div>
	<div v-html="html"></div>
	<div style="background-image: linear-gradient(-90deg, rgba(0,0,0,0.00) 11%, #D8D8D8 100%);height:1px;" class="flex1 marginl20"></div>
</div>
<div style="display: none;" v-show="!midDataNoMore&&!items.length">
	<slot></slot>
</div>
<tg-loadding class="paddingv50" style="display: none;" v-show="midDataNoMore&&items.length"></tg-loadding>
</template>

<script>
import maple from 'maple';
import tgLoadding from 'javascript/libs/tg/component/loadding/index.js';
export default {
	props: {
		items: {
			type: Array
			, default: []
		},
		midDataNoMore:{
			type:Boolean,
			default:false
		},
		html:{
			type:String,
			default:'哎呦~一不留心就到底啦！'
		}
	},
	events:{
		midDataNoMore:function(noMore){
			this.midDataNoMore=noMore;
		}
	}
};
</script>
